import { z } from 'zod';
import {
  TenantIdSchema,
  UlidSchema,
  IsoDateSchema,
  IsoTimestampSchema,
} from './common.js';

export const VinculoUnidadSchema = z.object({
  id: UlidSchema,
  tenantId: TenantIdSchema,
  viviendaId: UlidSchema,
  accesorioId: UlidSchema,
  fechaInicio: IsoDateSchema,
  fechaFin: IsoDateSchema.nullable(),
  createdAt: IsoTimestampSchema,
  updatedAt: IsoTimestampSchema,
});
export type VinculoUnidad = z.infer<typeof VinculoUnidadSchema>;

export const CrearVinculoRequestSchema = VinculoUnidadSchema.pick({
  viviendaId: true,
  accesorioId: true,
  fechaInicio: true,
});
export type CrearVinculoRequest = z.infer<typeof CrearVinculoRequestSchema>;

export const CerrarVinculoRequestSchema = z.object({
  fechaFin: IsoDateSchema,
});
export type CerrarVinculoRequest = z.infer<typeof CerrarVinculoRequestSchema>;
